import { createFileRoute, useRouter } from "@tanstack/react-router";
import { LogViewer } from ":features/logs_/ui/log-viewer";
import { logger } from ":shared/lib/logger";
import { useTranslation } from "react-i18next";

function checkDebugAccess(): boolean {
	const isDev = import.meta.env.DEV;

	if (typeof window === "undefined") {
		return isDev;
	}

	try {
		const hasDebugFlag = localStorage.getItem("hoopoe_debug_logs") === "true";
		return isDev || hasDebugFlag;
	} catch (error) {
		logger.error(
			"Failed to check localStorage for debug flag",
			error,
			"debug-logs",
		);
		return isDev;
	}
}

export const Route = createFileRoute("/$locale/dashboard/debug-logs")({
	component: DebugLogsComponent,
});

function DebugLogsComponent() {
	const { t } = useTranslation();
	const router = useRouter();
	const isAuthorized = checkDebugAccess();

	if (!isAuthorized) {
		logger.warn(
			"Unauthorized access attempt to debug logs page",
			undefined,
			"debug-logs",
		);
		router.navigate({ to: "/", replace: true });
		return null;
	}

	logger.info("Debug logs page accessed", { isAuthorized }, "debug-logs");

	return (
		<>
			<title>
				{t("pages.debugLogs.title")} - {t("app.name")}
			</title>
			<meta name="description" content={t("pages.debugLogs.description")} />
			<LogViewer />
		</>
	);
}
